// Hook for managing layout preferences
import { useCallback, useEffect, useState } from 'react';

import { useDebounce } from '@uidotdev/usehooks';

import { loadLayoutSettings, saveLayoutSettings } from '../lib/layoutSettings';

export const useLayoutPreferences = () => {
  const [settings, setSettings] = useState(() => loadLayoutSettings());
  const debouncedSettings = useDebounce(settings, 200);

  // Persist whenever (debounced) layout preferences change
  useEffect(() => {
    saveLayoutSettings(debouncedSettings);
  }, [debouncedSettings]);

  const setLayoutPref = useCallback((name, valueOrFn) => {
    setSettings((previousSettings) => {
      const value = typeof valueOrFn === 'function' ? valueOrFn(previousSettings[name]) : valueOrFn;
      return { ...previousSettings, [name]: value };
    });
  }, []);

  return {
    settings,
    setLayoutPref,
  };
};
